import { Injectable } from '@angular/core';
import Assembleia from '../../../../models/assembleia/assembleia.model';
import { hasPerm, Permission } from '../../../../shared/auth/permission.enum';
import { AbAssembleiaValidation } from 'app/abstract/full-pages/assembleia/assembleia-validation.abstract';

@Injectable({ providedIn: 'root' })
export class AssembleiaValidationsService extends AbAssembleiaValidation {


  hasAssembleiaInicioVotacaoIniciada(assembleia: Assembleia) {
    return assembleia.votacaoIniciada;
  }

  hasAssembleiaDataExpirada(assembleia: Assembleia) {

    return assembleia.expirada;
  }

  public convertToValidDate(dataString: string): Date {
    const dataStringArray = dataString.split(' ');
    const dataStringFirstPartArray = dataStringArray[0].split('/')
    const dataStringFirstPart = `${dataStringFirstPartArray[2]}-${dataStringFirstPartArray[1]}-${dataStringFirstPartArray[0]}`
    const formatedDateString = dataStringFirstPart + 'T' + dataStringArray[1];
    return new Date(formatedDateString);
  }

  hasAssembleiaFimVotacaoFinalizada(assembleia: Assembleia) {
    return assembleia.votacaoFinalizada;
  }


  isAssembleiaFinalizada(assembleia: Assembleia) {
    return assembleia.votacaoFinalizada || assembleia.expirada;
  }

  isAssembleiaOnline(assembleia: Assembleia) {
    return assembleia.modalidadeAssembleia === 'ONLINE';
  }

  get isAdmin() {
    return hasPerm(Permission.ASSEMBLEIA_CREATE);
  }
}
